<template>
	<table-paginator :data="products" @pagechange="$emit('pagechange', $event)">
		<div class="row">
			<template v-for="(row, index) in products.data">
				<div
					class="col-md-2 mb-4"
					@click="$emit('storeProduct', row.id)"
					:key="index"
				>
					<div class="card">
						<div class="card-body">
							<div class="d-flex justify-content-center align-self-center">
								<img class="product-img" v-lazy="row.image_url" />
							</div>
							<br />
							<div class="row">
								<div class="col-md-12">
									{{ row.description }}
									<br />
									<small class="text-muted"> {{ row.brand }}</small>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									{{ row.price | decimal }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
		<!-- <table class="customTable table table-hover">
      <tr>
        <th>Descricao</th>
        <th>Marca</th>
        <th>Preço</th>
      </tr>
      <tbody>
        <tr v-for="(row, index) in products.data" @click="storeProduct(row.id, index)" :key="row.id">
          <td style="cursor:pointer">{{ row.description }}</td>
          <td style="cursor:pointer">{{ row.brand }}</td>
          <td style="cursor:pointer">{{ row.price | decimal}}</td>
        </tr>
      </tbody>
    </table>-->
	</table-paginator>
</template>

<script>
	import TablePaginator from "../../sections/TablePaginator";
	export default {
		components: {
			TablePaginator
		},

		props: {
			products: {}
		},

		methods: {
		}
	};
</script>

<style>

.product-img {
  /* display: block;
  max-width:200px;
  max-height:200px;
  width: auto;
  height: auto; */
  display: block;
  /* max-width:200px; */
  max-height:200px;
  min-height:200px;
  width: 100%;
  height:auto;
  object-fit: scale-down;
}

</style>